// extracted by mini-css-extract-plugin
export default {"maintainance-page":"maintainence_maintainance-page__-Yaz2"};